import {
  PCMP_REQUEST_STATUS_LABELS,
  PCMP_REQUEST_STATUS_TONE,
} from '../../constants/pcmpRequest.constants';
import type { PcmpRequestStatus } from '../../types/pcmpRequest.types';
import { PcmpStatusPill } from '../PcmpProposalDetail/PcmpStatusPill';

export function PcmpRequestStatusPill({ status }: { status: PcmpRequestStatus }) {
  return (
    <PcmpStatusPill tone={PCMP_REQUEST_STATUS_TONE[status]}>
      {PCMP_REQUEST_STATUS_LABELS[status]}
    </PcmpStatusPill>
  );
}
